import { SERVICE_AREAS } from "../../constants/brands";

export const ServiceArea = () => (
  <section className="py-16 md:py-24 bg-white" data-testid="service-area-section">
    <div className="container-custom">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-[#1F2937] mb-4" style={{ fontFamily: "Manrope" }}>
          Our Service Area
        </h2>
        <p className="text-lg text-[#4B5563] max-w-2xl mx-auto">
          We provide same-day mobile meetups throughout the Jacksonville, FL area. Meet us at a convenient public location near you!
        </p>
      </div>

      <div className="rounded-2xl overflow-hidden shadow-lg border border-gray-200">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d441281.5765498285!2d-81.97676804453123!3d30.34805440000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e5b716f1ceafeb%3A0xc4cd7d3896fcc7e2!2sJacksonville%2C%20FL!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Cash for Test Strips Jacksonville Service Area Map"
          className="w-full"
        ></iframe>
      </div>

      <div className="mt-8 grid grid-cols-3 md:grid-cols-9 gap-4 text-center">
        {SERVICE_AREAS.map((location) => (
          <div key={location} className="bg-[#F5F5F0] px-3 py-2 rounded-lg">
            <span className="text-sm font-medium text-[#1F2937]">{location}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);
